import React, { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet';
import { useDispatch, useSelector } from 'react-redux';
import { Redirect, Route, Switch, useLocation } from 'react-router-dom';
import {
  NotAuthorized,
  NotFound,
} from '@iarcpsu/emanufac-components/src/components/Error';
import { MainFooter } from '@iarcpsu/emanufac-components/src/components/Footers';
import { Loading } from '@iarcpsu/emanufac-components/src/components/Loading';
import { HomeNavbar } from '@iarcpsu/emanufac-components/src/components/Navbars';
import { MainSidebar } from '@iarcpsu/emanufac-components/src/components/Sidebar';

import * as actions from '../redux/actions';
import accessRight from '../utils/functions/accessRight';
import {
  Conversions,
  CreateResultingFunctionType,
  DetailResultingFunctionType,
  EditConversion,
  EditOrganizationConstant,
  EditResultingFunctionType,
  EditUnit,
  OrganizationConstants,
  ResultingFunctionType,
  Units,
} from '../views/KM';
import { DashboardView, SettingView } from '../views/MMS';
// Sales and Purchase Management
export const KM = () => {
  const module = 'KM';
  const prefix = '/km';
  const name = 'คลังข้อมูลองค์กร';
  const dispatch = useDispatch();
  const { pathname } = useLocation();

  const me = useSelector((state) => state.me);
  const availableModule = useSelector((state) => state.availableModule);
  const information = useSelector((state) => state.information);

  const [isMobileNavOpen, setMobileNavOpen] = useState(false);
  const [sidebarOpen, setSidebarOpen] = useState(true);

  const handleOnMobileNavOpen = () => {
    setMobileNavOpen(true);
  };

  const handleOnMobileNavClose = () => {
    setMobileNavOpen(false);
  };

  useEffect(() => {
    console.log('Layout: KM');
    dispatch(actions.meGet());
    dispatch(actions.informationAll());
    dispatch(actions.availableModuleAll());
    return () => {};
  }, []);

  if (!me?.userData) {
    return <Loading />;
  }

  if (accessRight(me, module, 0, availableModule)) {
    return (
      <div className="min-h-screen">
        <Helmet>
          <meta charSet="utf-8" />
          <title>คลังข้อมูลองค์กร - {information?.name || 'E-Manufac'}</title>
        </Helmet>
        <MainSidebar
          onMobileClose={handleOnMobileNavClose}
          openMobile={isMobileNavOpen}
          me={me}
          isTaskbarOpen={sidebarOpen}
          setIsTaskbarOpen={setSidebarOpen}
        />
        <HomeNavbar onMobileNavOpen={handleOnMobileNavOpen} />
        <div
          className={`${
            sidebarOpen ? 'lg:ml-64' : ''
          }   min-h-screen  pt-16 px-8 `}
        >
          <div className="py-4">
            <Switch>
              <Redirect exact from={`${prefix}`} to={`${prefix}/unit`} />
              <Redirect from="/:url*(/+)" to={pathname.slice(0, -1)} />
              <Route exact path={`${prefix}/unit`}>
                <Units title="หน่วยวัดค่า" subtitle={name} />
              </Route>
              <Route exact path={`${prefix}/unit/edit/:id`}>
                <EditUnit title="แก้ไขหน่วยวัดค่า" subtitle={name} />
              </Route>
              <Route exact path={`${prefix}/conversion`}>
                <Conversions title="การแปลงหน่วย" subtitle={name} />
              </Route>
              <Route exact path={`${prefix}/conversion/edit/:id`}>
                <EditConversion title="แก้ไขการแปลงหน่วย" subtitle={name} />
              </Route>
              <Route exact path={`${prefix}/organization-constant`}>
                <OrganizationConstants title="ค่าคงที่" subtitle={name} />
              </Route>
              <Route exact path={`${prefix}/organization-constant/edit/:id`}>
                <EditOrganizationConstant
                  title="แก้ไขค่าคงที่"
                  subtitle={name}
                />
              </Route>
              <Route exact path={`${prefix}/process-template`}>
                <SettingView.ProcessTemplate
                  title="สูตรการผลิต"
                  subtitle={name}
                />
              </Route>
              <Route exact path={`${prefix}/process-template/edit/:id`}>
                <SettingView.EditProcessTemplate
                  title="สูตรการผลิต"
                  subtitle={name}
                />
              </Route>
              <Route exact path={`${prefix}/process-template/view/:id`}>
                <SettingView.DetailProcessTemplate
                  title="รายละเอียดสูตรการผลิต"
                  subtitle={name}
                />
              </Route>
              <Route exact path={`${prefix}/process-template/create`}>
                <SettingView.CreateProcessTemplate
                  title="สร้างสูตรการผลิต"
                  subtitle={name}
                />
              </Route>
              <Route exact path={`${prefix}/mo-template/`}>
                <SettingView.MOTemplates
                  title="สูตรคำสั่งผลิต"
                  subtitle={name}
                />
              </Route>
              <Route exact path={`${prefix}/mo-template/view/:id`}>
                <SettingView.DetailMOTemplate
                  title="รายละเอียดสูตรคำสั่งผลิต"
                  subtitle={name}
                />
              </Route>
              <Route exact path={`${prefix}/mo-template/edit/:id`}>
                <SettingView.EditMOTemplate
                  title="แก้ไขสูตรคำสั่งผลิต"
                  subtitle={name}
                />
              </Route>
              <Route exact path={`${prefix}/mo-template/create`}>
                <SettingView.CreateMOTemplate
                  title="สร้างสูตรคำสั่งผลิต"
                  subtitle={name}
                />
              </Route>
              <Route exact path={`${prefix}/measurement-type`}>
                <SettingView.MeasurementType
                  title="ตัวแปรวัดค่า"
                  subtitle={name}
                />
              </Route>
              <Route exact path={`${prefix}/measurement-type/edit/:id`}>
                <SettingView.EditMeasurementType
                  title="แก้ไขตัวแปรวัดค่า"
                  subtitle={name}
                />
              </Route>
              <Route exact path={`${prefix}/resulting-function-type`}>
                <ResultingFunctionType
                  title="ฟังก์ชันการแสดงผล"
                  subtitle={name}
                />
              </Route>
              <Route exact path={`${prefix}/resulting-function-type/edit/:id`}>
                <EditResultingFunctionType
                  title="แก้ไขฟังก์ชันการแสดงผล"
                  subtitle={name}
                />
              </Route>
              <Route
                exact
                path={`${prefix}/resulting-function-type/detail/:id`}
              >
                <DetailResultingFunctionType
                  title="รายละเอียดฟังก์ชันการแสดงผล"
                  subtitle={name}
                />
              </Route>
              <Route exact path={`${prefix}/bom-template`}>
                <SettingView.BOMTemplates
                  title="รายการสูตรส่วนผสม"
                  subtitle={name}
                />
              </Route>
              <Route exact path={`${prefix}/bom-template/create`}>
                <SettingView.CreateBOMTemplate
                  title="สร้างสูตรส่วนผสม"
                  subtitle={name}
                />
              </Route>
              <Route exact path={`${prefix}/bom-template/view/:id`}>
                <SettingView.ViewBOMTemplate
                  title="รายละเอียดสูตรส่วนผสม"
                  subtitle={name}
                />
              </Route>
              <Route exact path={`${prefix}/bom-template/edit/:id`}>
                <SettingView.EditBOMTemplate
                  title="แก้ไขสูตรส่วนผสม"
                  subtitle={name}
                />
              </Route>{' '}
              <Route exact path={`${prefix}/resulting-function-type/create`}>
                <CreateResultingFunctionType
                  title="สร้างสูตรการแสดงผล"
                  subtitle={name}
                />
              </Route>
              <Route path="*">
                <NotFound />
              </Route>
            </Switch>
          </div>
        </div>
        <div className="lg:ml-64">
          <MainFooter />
        </div>
      </div>
    );
  }

  return (
    <div>
      <div className="min-h-screen">
        <MainSidebar
          onMobileClose={handleOnMobileNavClose}
          openMobile={isMobileNavOpen}
          me={me}
        />
        <HomeNavbar onMobileNavOpen={handleOnMobileNavOpen} />
        <NotAuthorized />
        <div className="lg:ml-64">
          <MainFooter />
        </div>
      </div>
    </div>
  );
};

export default KM;
